import { createReducer, on } from '@ngrx/store';
import { loginSuccess, loginFailure, logout, logoutSuccess } from './auth.actions';

export interface AuthState {
  userData: any | null;
  error: string | null;
}

export const initialState: AuthState = {
  userData: null,
  error: null,
};

export const authReducer = createReducer(
  initialState,
  on(loginSuccess, (state, { userData }) => {
    console.log('Reducer triggered for loginSuccess:', userData);
    return {
      ...state,
      userData,
      error: null,
    };
  }),
  on(loginFailure, (state, { error }) => ({
    ...state,
    userData: null,
    error,
  })),
  on(logout, logoutSuccess, () => {
    console.log('Reducer triggered for logout: resetting to initial state');
    return initialState;
  })
);
